export const CustomMenuListCode = {
    DEFAULT: 'DEFAULT',
    HOTPLACE: 'HOTPLACE',
    EVENT: 'EVENT'
} as const;

export type CustomMenuListCodeType = (typeof CustomMenuListCode)[keyof typeof CustomMenuListCode];

type MenuForCodeResolve = {
    menuCode?: string | null;
};

/**
 * Resolves list-type layout variant from menuCode.
 * - No menuCode → default list-type (carousel + detail page)
 * - menuCode === HOTPLACE → Hotplace master-detail layout
 */
export const resolveMenuCode = (menu: MenuForCodeResolve): string | undefined => {
    return menu.menuCode ?? undefined;
};
